module.exports = __webpack_public_path__ + "img/orchid.13d5140b.jpg";